import { Divider } from 'components/Divider';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownHeaderTrigger } from 'components/Dropdown/HeaderTrigger/DropdownHeaderTrigger';
import { DropdownMenu } from 'components/Dropdown/menus/Menu/DropdownMenu';
import { DropdownMenuItem } from 'components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { Icon } from 'components/Icon/Icon';
import { Stack } from 'components/Stack/Stack';
import { ListingType } from 'types/ListingType';
import { OrgType } from 'utils/constants/general/orgTypes';

import { ReportListingMenuItem } from './ReportListingMenuItem';
import { SaveOrgMenuItem } from './SaveOrgMenuItem';
import { ShareMenuItem } from './ShareMenuItem';

type Props = {
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  orgId?: string;
  orgName?: string;
  orgType?: OrgType;
};

export function ListingActionsDropdown({
  listingId,
  listingType,
  listingUrl,
  orgId,
  orgType,
  orgName,
}: Props) {
  return (
    <Dropdown
      aria-label={getText('View more actions')}
      qaId="listings-more-actions"
      trigger={
        <DropdownHeaderTrigger
          qaId="listings-more-actions-toggle"
          variant="grey"
        >
          <Icon name="3-dots" size={18} />
        </DropdownHeaderTrigger>
      }
    >
      <DropdownMenu width={180} mobilePlacement="top-right">
        <Stack divider={<Divider marginBottom={0} marginTop={0} />}>
          <DropdownMenuItem mobileOnly>
            <ShareMenuItem
              listingId={listingId}
              listingType={listingType}
              listingUrl={listingUrl}
              orgId={orgId}
            />
          </DropdownMenuItem>

          {orgId && orgName && orgType ? (
            <DropdownMenuItem>
              <SaveOrgMenuItem
                orgId={orgId}
                orgName={orgName}
                orgType={orgType}
              />
            </DropdownMenuItem>
          ) : null}

          <DropdownMenuItem>
            <ReportListingMenuItem
              listingId={listingId}
              listingType={listingType}
            />
          </DropdownMenuItem>
        </Stack>
      </DropdownMenu>
    </Dropdown>
  );
}
